export default "__VITE_ASSET__HcAaD27T__"